import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { HighlightIconContainer } from "./styles";
export var HighlightIcon = forwardRef(function HighlightIcon(_a, ref) {
    var icon = _a.icon, color = _a.color, size = _a.size, props = __rest(_a, ["icon", "color", "size"]);
    return (_jsx(HighlightIconContainer, __assign({ ref: ref, color: color, size: size }, props, { children: _jsx("div", { children: icon }) })));
});
//# sourceMappingURL=index.js.map